import React from 'react';
import './DesignInsightPage.scss';
import DIPredavacComponent from '../DIPredavacComponent/DIPredavacComponent';
import DjordjeVasic from '../../assets/json/predavaci/djordjevasic.json';
import DijanaSimic from '../../assets/json/predavaci/dijanasimic.json';
import Tamara from '../../assets/json/predavaci/tamara.json';
import DragicaNikodinovic from '../../assets/json/predavaci/dragicanikodinovic.json';
import AndrejJosifovski from '../../assets/json/predavaci/andrejjosifovski.json';
import BrankoAndrejevic from '../../assets/json/predavaci/brankoandrejevic.json';
import Katarina from '../../assets/json/predavaci/katarina.json';
import Jovan from '../../assets/json/predavaci/jovankrstic.json';
import Petar from '../../assets/json/predavaci/petarmitrovic.json';
import Mihajlo from '../../assets/json/predavaci/mihajlo.json';


const DesignInsightPage: React.FC = () => {
    return (
        <div className='design-insight-container' id='scrollElement1'>
            <div className='title-container'>
                <h1 className='document-main-title'>Design Insight</h1>
            </div>
            <div className='text-container'>
                <p>Design Insight predstavlja niz predavanja koja prate inovacije i aktuelne teme u svetu dizajna. Pored novih tema i trendova, obrađuju se novi alati, tehnologije i ideje. Cilj je da se učesnicima predstave nove mogućnosti u svetu grafičkog, web, arhitektonskog ili industrijskog dizajna. Ovo je način da im se omogući da čuju o praktičnom iskustvu predavača i stručnjaka u svojoj oblasti. Predavanja su besplatna i otvorena za sve zainteresovane studente, bilo da su učesnici seminara ili ne.</p>
                <p>Održaće se 13. maja.</p>
            </div>
            {/* <div className='di-prijava-div'>
                <h3 className='di-prijava-title'>Prijavi se za <br className='mobile-br'></br>Design Insight!</h3>
                <button className='di-prijava-btn' onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLScgwCaxEash2wOnLlySjMhkGgyEllJ9LhU-uvQD1uL4aLxsOQ/viewform?usp=header", "_blank")}>Design Insight<br></br>Prijava</button>
            </div> */}

            <div className='di-predavaci-container'>
                <h1 className='di-predavaci-title'>Predavači</h1>
                <DIPredavacComponent data={DjordjeVasic}></DIPredavacComponent>
                <DIPredavacComponent data={DijanaSimic}></DIPredavacComponent>
                <DIPredavacComponent data={BrankoAndrejevic}></DIPredavacComponent>
                <DIPredavacComponent data={DragicaNikodinovic}></DIPredavacComponent>
                <DIPredavacComponent data={AndrejJosifovski}></DIPredavacComponent>
                <DIPredavacComponent data={Tamara}></DIPredavacComponent>
                <DIPredavacComponent data={Katarina}></DIPredavacComponent>
                <DIPredavacComponent data={Jovan}></DIPredavacComponent>
                <DIPredavacComponent data={Petar}></DIPredavacComponent>
                <DIPredavacComponent data={Mihajlo}></DIPredavacComponent>
                
            </div>
        </div>
    );
};

export default DesignInsightPage;